import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import logger from "../../logger";

const RouteManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  // Track if user was authenticated to distinguish logout from initial page load
  const wasAuthenticatedRef = useRef(false);

  useEffect(() => {
    if (isAuthenticated && location.pathname !== "/login" && location.pathname !== "/") {
      sessionStorage.setItem("lastRoute", location.pathname);
      wasAuthenticatedRef.current = true;
    }
  }, [location.pathname, isAuthenticated]);

  const clearAllSessionData = () => {
    sessionStorage.removeItem("lastRoute");
    sessionStorage.removeItem("okta-oauth-state");
    sessionStorage.removeItem("okta-oauth-code-verifier");
    sessionStorage.removeItem("okta-oauth-redirect-uri");
    sessionStorage.removeItem("forceLoginPrompt");
    sessionStorage.removeItem("oktaTokens");
    sessionStorage.removeItem("authTokens");
    localStorage.removeItem("okta-dialog-config");

    logger.debug("All session and route data cleared on logout");
  };

  // Only clear data when user actually logs out, not on initial page load
  useEffect(() => {
    if (!loading) {
      if (wasAuthenticatedRef.current && !isAuthenticated) {
        clearAllSessionData();
        wasAuthenticatedRef.current = false;
      }
    }
  }, [isAuthenticated, loading]);

  // Restore saved route when app loads if user is already authenticated
  useEffect(() => {
    if (!loading && isAuthenticated) {
      const savedRoute = sessionStorage.getItem("lastRoute");
      if ((location.pathname === "/login" || location.pathname === "/") && savedRoute) {
        navigate(savedRoute, { replace: true });
      }
    }
  }, [isAuthenticated, loading, navigate, location.pathname]);

  return null;
};

export default RouteManager;
